import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import DescargasCard from './components/DescargasCard';

const DescargasMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Inicio' },
            { name: 'Descarga' },
            { name: 'Descargas' }
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <DescargasCard />
      </Col>
    </Row>
  </Container>
);

export default DescargasMain;
